import ReduxQuerySync from 'redux-query-sync';
export const initQuerySync = (store) => {
    ReduxQuerySync({
        store,
        params: {
            address: {
                selector: (state) => { var _a; return (_a = state.storelocator) === null || _a === void 0 ? void 0 : _a.address; },
                action: (value) => ({ type: 'storelocator/setAddress', payload: value }),
            },
            location: {
                selector: (state) => {
                    var _a, _b, _c, _d;
                    if (((_a = state.storelocator) === null || _a === void 0 ? void 0 : _a.center) && ((_b = state.storelocator) === null || _b === void 0 ? void 0 : _b.zoom)) {
                        return `${(_c = state.storelocator.center) === null || _c === void 0 ? void 0 : _c.lat},${(_d = state.storelocator.center) === null || _d === void 0 ? void 0 : _d.lng},${state.storelocator.zoom}`;
                    }
                    else {
                        return '';
                    }
                },
                action: (value) => ({ type: 'storelocator/updateLocationFromQuery', payload: value }),
                defaultValue: '',
            },
            storeId: {
                selector: (state) => { var _a; return (_a = state.storelocator) === null || _a === void 0 ? void 0 : _a.currentStoreId; },
                action: (value) => ({ type: 'storelocator/setCurrentStore', payload: value }),
            },
            services: {
                selector: (state) => {
                    var _a, _b;
                    return ((_a = state.storelocator) === null || _a === void 0 ? void 0 : _a.filters.services.length) > 0 ? (_b = state.storelocator) === null || _b === void 0 ? void 0 : _b.filters.services.reduce((result, service) => `${result},${service}`, '') : '';
                },
                action: (value) => ({ type: 'storelocator/updateServiceFromQuery', payload: value }),
                defaultValue: '',
            },
            collections: {
                selector: (state) => {
                    var _a, _b;
                    return ((_a = state.storelocator) === null || _a === void 0 ? void 0 : _a.filters.collections.length) > 0 ? (_b = state.storelocator) === null || _b === void 0 ? void 0 : _b.filters.collections.reduce((result, service) => `${result},${service}`, '') : '';
                },
                action: (value) => ({ type: 'storelocator/updateCollectionsFromQuery', payload: value }),
                defaultValue: '',
            },
        },
        // Initially set the store's state to the current location.
        initialTruth: 'location',
    });
};
